import FormComponent from '../../../../components/FormComponent';

const SNACKBAR_TYPE = 'alert';
const BUTTON_ICON = 'open-in-new';
const BUTTON_TARGET = '_blank';
const SNACKBAR_CLASSES = 'lta-snackbar--full u-mt-2 u-mb-3';

/**
 * Display-only alert snackbar driven by steps.js (dependent question).
 * Supports message + optional CTA button, or alertItems list.
 */
class InsuranceAlertSnackbar extends FormComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this.value = {
			fieldName: config?.data?.fieldName || 'insuranceAlertSnackbar',
			value: 'displayed'
		};
	}

	markup(_value, data = {}) {
		const { message = '', buttonLabel = '', buttonUrl = '', alertItems = [] } = data;

		if (!message && (!alertItems || alertItems.length === 0)) {
			return '';
		}

		const listMarkup =
			alertItems?.length > 0
				? `<ul>
					${alertItems.map((item) => `<li><span>${item}</span></li>`).join('')}
				</ul>`
				: '';

		const messageMarkup = message
			? `<p class="lta-snackbar__label u-body2 ${buttonLabel ? 'u-mb-2' : 'u-mb-0'}" aria-label="${message}">${message}</p>`
			: '';

		const buttonMarkup =
			buttonLabel && buttonUrl
				? `<a
					href="${buttonUrl}"
					target="${BUTTON_TARGET}"
					rel="noopener noreferrer"
					class="p-venue-registration-insurance-info__visit-howdens-btn u-hstack u-gap-1 u-py-1 u-px-3 u-body2 u-fw-bold u-bg-white u-text-grey-dark-slate u-rounded text-decoration-none"
				>
					<svg class="lta-icon" width="1em" height="1em" fill="currentColor" aria-hidden="true">
						<use xlink:href="/static/images/icons/lta-icons.svg#${BUTTON_ICON}"></use>
					</svg>
					${buttonLabel}
				</a>`
				: '';

		return `
			<div class="lta-snackbar lta-snackbar--${SNACKBAR_TYPE} ${SNACKBAR_CLASSES}" role="alert">
				${messageMarkup}
				${listMarkup}
				${buttonMarkup}
			</div>
		`;
	}

	validate() {
		return true;
	}
}

export default InsuranceAlertSnackbar;
